import { Page } from './Page';
import { Section } from './Section';
import { Column } from './Column';
import { Text } from './Text';
import { Image } from './Image';
import { Group } from './Group';
import { Button } from './Button'; // Uses useField hooks
import { Divider } from './Divider';
import { Wrapper } from './Wrapper';
import { Spacer } from './Spacer';

import { Raw } from './Raw';
import { Accordion } from './Accordion';
import { AccordionElement } from './AccordionElement';
import { AccordionTitle } from './AccordionTitle';
import { AccordionText } from './AccordionText';
import { Carousel } from './Carousel';
import { Hero } from './Hero';
import { Navbar } from './Navbar';
// Critical: Import components using React Final Form hooks synchronously to prevent context issues
import { Social } from './Social'; // Uses useField hooks
import { Table } from './Table';
import { BasicType, AdvancedType, LEGACY_RAW_BLOCK_TYPE } from '@bay-email/core';
import { AdvancedTable } from './AdvancedTable';
import { Listing } from './Listing';
import { CriteriaBlock as ListingsCriteriaBlock } from './CriteriaBlock';
import { SingleListing } from './SingleListing';
import { CustomListing } from './CustomListing';
import { DynamicImage } from './DynamicImage';
// User blocks temporarily disabled
// import { Users } from './Users';
// import { UsersCriteriaBlock } from './UsersCriteriaBlock';
// import { SingleUser } from './SingleUser';
// Define the custom block type locally to avoid circular dependencies
const CustomBlockType = {
	LISTINGS_BLOCK: 'listings_block' as const,
	CRITERIA_BLOCK: 'criteria_block' as const,
	SINGLE_LISTING_BLOCK: 'text_single_listing' as const,
	CUSTOM_LISTING_BLOCK: 'custom_listing_block' as const,
	DYNAMIC_IMAGE: 'dynamic_image' as const,
	// USERS_CRITERIA_BLOCK: 'users_criteria_block' as const,
	// USERS_BLOCK: 'users_block' as const,
	// SINGLE_USER_BLOCK: 'text_single_user' as const,
};

export const blocks = {
	[BasicType.PAGE]: Page,
	[BasicType.SECTION]: Section,
	[BasicType.COLUMN]: Column,
	[BasicType.TEXT]: Text,
	[BasicType.IMAGE]: Image,
	[BasicType.GROUP]: Group,
	[BasicType.BUTTON]: Button,
	[BasicType.DIVIDER]: Divider,
	[BasicType.WRAPPER]: Wrapper,
	[BasicType.SPACER]: Spacer,
	[BasicType.RAW]: Raw,
	[LEGACY_RAW_BLOCK_TYPE]: Raw,
	[BasicType.ACCORDION]: Accordion,
	[BasicType.ACCORDION_ELEMENT]: AccordionElement,
	[BasicType.ACCORDION_TITLE]: AccordionTitle,
	[BasicType.ACCORDION_TEXT]: AccordionText,
	[BasicType.CAROUSEL]: Carousel,
	[BasicType.HERO]: Hero,
	[BasicType.NAVBAR]: Navbar,
	[BasicType.SOCIAL]: Social,
	[BasicType.TABLE]: Table,

	[AdvancedType.TEXT]: Text,
	[AdvancedType.IMAGE]: Image,
	[AdvancedType.BUTTON]: Button,
	[AdvancedType.DIVIDER]: Divider,
	[AdvancedType.SPACER]: Spacer,
	[AdvancedType.ACCORDION]: Accordion,
	[AdvancedType.CAROUSEL]: Carousel,
	[AdvancedType.NAVBAR]: Navbar,
	[AdvancedType.SOCIAL]: Social,
	[AdvancedType.TABLE]: AdvancedTable,

	[AdvancedType.HERO]: Hero,
	[AdvancedType.WRAPPER]: Wrapper,
	[AdvancedType.SECTION]: Section,
	[AdvancedType.GROUP]: Group,
	[AdvancedType.COLUMN]: Column,

	// Custom blocks
	[CustomBlockType.LISTINGS_BLOCK]: Listing,
	[CustomBlockType.CRITERIA_BLOCK]: ListingsCriteriaBlock,
	[CustomBlockType.SINGLE_LISTING_BLOCK]: SingleListing,
	[CustomBlockType.CUSTOM_LISTING_BLOCK]: CustomListing,
	[CustomBlockType.DYNAMIC_IMAGE]: DynamicImage,
	// User blocks temporarily disabled
	// [CustomBlockType.USERS_CRITERIA_BLOCK]: UsersCriteriaBlock,
	// [CustomBlockType.USERS_BLOCK]: Users,
	// [CustomBlockType.SINGLE_USER_BLOCK]: SingleUser,
};
